var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmEdoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 0H0.75C0.335625 0 0 0.335625 0 0.75V1.5C0 1.91438 0.335625 2.25 0.75 2.25H1.5V15C1.5 15.8283 2.17172 16.5 3 16.5H12.375V18.5494L8.73516 22.1892C8.44219 22.4822 8.44219 22.957 8.73516 23.25L9.26531 23.7802C9.55828 24.0731 10.0331 24.0731 10.3261 23.7802L13.5 20.6063L16.6744 23.7806C16.9673 24.0736 17.4422 24.0736 17.7352 23.7806L18.2648 23.25C18.5578 22.957 18.5578 22.4822 18.2648 22.1892L14.625 18.5494V16.5H24C24.8283 16.5 25.5 15.8283 25.5 15V2.25H26.25C26.6644 2.25 27 1.91438 27 1.5V0.75C27 0.335625 26.6644 0 26.25 0ZM23.25 14.25H3.75V2.25H23.25V14.25Z",
    fill: "#8B8A90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmEdoc);
export default __webpack_public_path__ + "static/media/CMEdoc.fd686049.svg";
export { ForwardRef as ReactComponent };